<template>
  <div>
    <b-container fluid class="d-flex align-items-center back-wrapper">
          <b-row >
            <b-col lg="7" md="10">
              <router-link :to="{name: 'usuarios'}" class="back-item">
                  <img class="arrow-back" src="img/theme/icn_arrowback.svg" alt="">
                  <span>Usuarios</span>
              </router-link>
            </b-col>
          </b-row>
        </b-container>
    <div class="header pb-8 pt-5 pt-lg-6 d-flex align-items-center profile-header">
      <b-container fluid>
        <!-- Mask -->
        <span class="mask"></span>
        <!-- Header container -->
        <h1 class="text-center">Panel de Configuración</h1>
      </b-container>
    </div>

    <b-container fluid class="mt--6">
      <b-row>
        <b-col xl="12" class="order-xl-1">
          <card>
            <b-row align-v="center" slot="header" >
              <b-col cols="8">
                <h3 class="mb-0">Editar usuario</h3>
              </b-col>
            </b-row>

            <b-form @submit.prevent="updateProfile">
              <base-alert v-if="success === true" type="success" icon="ni ni-like-2 ni-lg" dismissible>
                <strong>¡Bien hecho!</strong> La información del usuario se actualizó exitosamente.
              </base-alert>
              <base-alert v-if="success === false" type="danger" icon="ni ni-like-2 ni-lg" dismissible>
                <strong>¡Error!</strong> {{error}}
              </base-alert>
              <h6 class="heading-small text-muted mb-4">Información del usuario</h6>
              <div class="pl-lg-4">
                <b-row>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Nombre de usuario"
                      placeholder="Nombre de usuario"
                      v-model="username"
                      name="Username"
                      required
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      type="text"
                      label="Correo electrónico"
                      placeholder="correo@email.com"
                      v-model="email"
                      name="Correo electrónico"
                      required
                    >
                    </base-input>
                  </b-col>
                </b-row>
                <b-row >
                  <b-col lg="6">
                    <base-input
                      type="password"
                      label="Contraseña"
                      placeholder=""
                      v-model="password"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <base-input
                      type="password"
                      label="Confirma contraseña"
                      placeholder=""
                      v-model="confirmPassword"
                    >
                    </base-input>
                  </b-col>
                  <b-col lg="6">
                    <label class="form-control-label" for="">Hospital al que pertenece el usuario</label>
                    <multiselect
                      :show-labels="false"
                      v-model="hospital"
                      :options="hospitals"
                      placeholder='Selecciona el hospital a asignar'
                      label="name"
                      track-by="id"
                      value-prop="id">
                    </multiselect>
                  </b-col>
                  <b-col lg="6">
                    <label class="form-control-label" for="">Tipo de usuario</label>
                    <multiselect
                      :show-labels="false"
                      v-model="admin"
                      :options="['Super','Admin','User','Ejecutivo','Store']"
                      placeholder='Selecciona el tipo de usuario'>
                    </multiselect>
                  </b-col>
                </b-row>
              </div>
              <hr class="my-4">
              <b-button type="submit" variant="primary" class="mt-4">Guardar</b-button>
              <b-button :to="{ name: 'usuarios'}" variant="danger" class="mt-4">Cancelar</b-button>
            </b-form>
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import axios from 'axios'
import qs from 'qs'

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      username: '',
      email: '',
      password: '',
      confirmPassword: '',
      admin: '',
      token: '',
      user: '',
      hospital: '',
      hospitals: [],
      success: '',
      error: ''
    };
  },
  methods: {
    updateProfile() {
      this.token = localStorage.getItem('token')
      this.user = localStorage.getItem('id_user')


      if(this.confirmPassword == this.password){
        var params
        if(this.password){
          params = {
            api_token: this.token,
            user_id: this.user,
            option: 'edit_user',
            u_id: this.$route.params.userId,
            u_name: this.username,
            u_pass: this.password ? this.password :  '',
            u_mail: this.email,
            u_role:this.admin,
            u_hospital: this.hospital[0] ? this.hospital[0].id : this.hospital.id
          }
        } else {
          params = {
            api_token: this.token,
            user_id: this.user,
            option: 'edit_user',
            u_id: this.$route.params.userId,
            u_name: this.username,
            u_mail: this.email,
            u_role:this.admin,
            u_hospital: this.hospital[0] ? this.hospital[0].id : this.hospital.id
          }
        }


        axios
        .post(
          process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php',
          qs.stringify(params),
        )
        .then((response) => {
          if (!response.data.error.code) {
            this.success = true
          } else {
            this.success = false
            this.error = response.data.error.description
          }
        })
        .catch((err) => {
          console.log(err)
        })
      } else {
        this.success = false
        this.error = 'La contraseña debe de coincidir con la confirmación.'
      }
    }
  },
  async created() {
    let temp = []
    this.token = localStorage.getItem('token')
    this.user = localStorage.getItem('id_user')
    await axios
      .post(
        process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php',
        qs.stringify({ api_token: this.token, user_id: this.user, option: 'get_catalogs'}),
      )
      .then((response) => {
        if (!response.data.error.code && response.data.hospitals) {
          Object.keys(response.data.hospitals).map((key) => [response.data.hospitals[key]]).map(function(value) {
              temp.push(value[0])
          })
          this.hospitals = temp
        }
      })
      .catch((err) => {
        console.log(err)
      })
    await axios
    .post(
      process.env.VUE_APP_ROUTE_BACKEND_API+'admin_api.php',
      qs.stringify({
        api_token: this.token,
        user_id: this.user,
        option: 'get_user',
        get_user: this.$route.params.userId
      }),
    )
    .then((response) => {
      if (!response.data.error.code) {
        this.username = response.data.user.name
        this.email = response.data.user.mail
        this.admin = response.data.user.role
        this.hospital = response.data.user.hospital_id ? this.hospitals.filter((x) => { return x.id ? x.id === response.data.user.hospital_id : x }) : ''
      }
    })
    .catch((err) => {
      console.log(err)
    })
  }
};
</script>
<style></style>
